<template>
    <div class="tabs">
        <ul class="nav nav-tabs tabSelector">
            <li v-for="(tab, index) in tabs" 
            class="nav-item" 
            :key="index" 
            @click="() => {selectedIndex = index}">
                <div class="nav-link"
                 :class="{active:selectedIndex == index}">
                    {{tab.tab_title}}
                </div>
            </li>
        </ul>
        <div class="tabs">
            <BaseLayout v-for="(layout, index) in selectedTab.tab_content_layouts" :key="index" :layoutData="layout"/>
        </div>
    </div>
</template>

<script>
import BaseLayout from '../layouts/BaseLayout'
export default {
  name: "Tabs",
  props: ["tabs", "acf_fc_layout"],
  components:{
      BaseLayout
  },
  data(){
      return{
          selectedIndex: 0
      }
  },
  computed:{
      selectedTab(){
          return this.tabs[this.selectedIndex]
      }
  }
};
</script>

<style lang="scss" scoped>
.tabs{
    min-height:300px;
}

ul li{
    &:before{
        display:none;
    }
}

// .tabSelector{
//     .tabTitle{
//         margin:2px;
//         padding:5px;
//         background:grey;
//         display:inline-block;
//         &.selected{
//             background:lightgrey;
//         }
//     }
// }


</style>
